import { useState, useEffect } from 'react';
import { 
  applyTheme, 
  getCurrentTheme, 
  getThemeById,
  getAvailableThemeIds,
  PREDEFINED_THEMES 
} from '../utils/themes';

/**
 * Hook for managing tenant theme
 * Provides theme selection, application, and persistence
 */
export const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useState(() => getCurrentTheme());
  const [isLoading, setIsLoading] = useState(false);

  // Initialize theme on mount
  useEffect(() => {
    applyTheme(currentTheme);
  }, []);

  // Apply theme and persist selection
  const selectTheme = (themeId) => {
    const theme = getThemeById(themeId);
    setCurrentTheme(theme);
    applyTheme(theme);
    return theme;
  };

  // Get all available themes for selection UI
  const getAvailableThemes = () => {
    const themeIds = getAvailableThemeIds();
    return themeIds.map(id => ({
      ...PREDEFINED_THEMES[id],
      selected: currentTheme.id === id
    }));
  };

  // Update theme colors (for custom color picker)
  const updateThemeColor = (colorKey, colorValue) => {
    const updatedTheme = {
      ...currentTheme,
      colors: {
        ...currentTheme.colors,
        [colorKey]: colorValue
      }
    };
    setCurrentTheme(updatedTheme);
    applyTheme(updatedTheme);
  };

  // Reset to default theme
  const resetTheme = () => {
    const defaultTheme = PREDEFINED_THEMES.modern;
    setCurrentTheme(defaultTheme);
    applyTheme(defaultTheme);
  };

  return {
    currentTheme,
    selectTheme,
    getAvailableThemes,
    updateThemeColor,
    resetTheme,
    isLoading,
    setIsLoading
  };
};
